import React from 'react';
import { Reveal } from './Reveal';
import { bonuses } from '../data/offer';
export function Bonuses() {
  return <section className="w-full bg-mist px-4 py-16 sm:py-20" data-id="element-19" data-mp="piy1ah937nhx">
      <div className="mx-auto max-w-6xl" data-id="element-20" data-mp="av35ut3p3515">
        <Reveal className="text-center" data-id="element-21" data-mp="aua7ogisxnum">
          <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-amber" data-id="element-22" data-mp="at8uo6i86ra9">
            Incluso con la collezione completa
          </p>
          <h2 className="mx-auto mt-3 max-w-4xl font-serif text-[2.75rem] leading-[1.02] text-navy sm:text-6xl" data-id="element-23" data-mp="1tc1brkw548v">
            🎁 5 Bonus Premium <span className="text-amber" data-id="element-24" data-mp="5xbgo6ufpx0n">Offerti con il tuo Acquisto</span>
          </h2>
          <span aria-hidden="true" className="mx-auto mt-6 block h-px w-24 bg-amber/60" data-id="element-25" data-mp="3o369yhbo54hb" />
          <p className="mx-auto mt-5 max-w-2xl text-sm text-slate sm:text-base" data-id="element-26" data-mp="3t1hlqxlixp26">
            Valore individuale di 15 EUR ciascuno — incluso gratuitamente durante il lancio.
          </p>
        </Reveal>

        <ul className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-27" data-mp="1r8tdg9u0wbfj">
          {bonuses.map((bonus, index) => <Reveal key={bonus.label} delay={index % 2 * 0.05} className={`h-full ${index === bonuses.length - 1 ? 'md:col-span-2 md:mx-auto md:w-[calc(50%-0.625rem)]' : ''}`} data-id="element-28" data-mp="3icvan7ku2bzt" data-mpi={index}>
              <li className="h-full overflow-hidden rounded-2xl border border-amber bg-surface shadow-elevated" data-id="element-29" data-mp="3n54xufukcxye">
                <img src={bonus.image} alt={`${bonus.label} — ${bonus.title} : ${bonus.subtitle}`} className="block h-auto w-full object-cover" loading="lazy" data-id="element-30" data-mp="2zfar8g0u85ml" />
              </li>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}